module.exports = __webpack_public_path__ + "static/media/10_l_kolonka_two_0.26_1.94.7ca1d66e.png";